<!-- === FONDO DE LA SECCIÓN === -->
<div class="grid-wrapper" id="servicios">
  <div class="wave-decoration"></div>

  <!-- === CONTENIDO DE HABILIDADES === -->
  <div class="skills-content">
    <section class="skills-section">
      <div class="skills-grid-modern">
        <div class="card-modern">
          <div class="skill-icon" aria-hidden="true"><i class="fas fa-user-doctor"></i></div>
          <p class="heading">PROFESIONALISMO</p>
          <p class="description">Enfoque terapéutico fresco, especializado y adaptado a las necesidades particulares.</p>
        </div>

        <div class="card-modern">
          <div class="skill-icon" aria-hidden="true"><i class="fas fa-heart"></i></div>
          <p class="heading">CERCANÍA</p>
          <p class="description">Conexión humana genuina, lejos de la frialdad clínica.</p>
        </div>

        <div class="card-modern">
          <div class="skill-icon" aria-hidden="true"><i class="fas fa-globe"></i></div>
          <p class="heading">ACOMPAÑAMIENTO</p>
          <p class="description">Rompiendo barreras geográficas con el uso de herramientas digitales.</p>
        </div>
      </div>
    </section>
  </div>
</div>
